import { ExtensionTypeOption } from 'src/app/pages/extension-register/models/extension-type-option.interface';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { filterDisplayNamedOption, filterNamedOption } from '../../select/shared/filter-named-option';
import { extensionTypeOptionActions } from './extension-type-option.actions';

export const extensionTypeOptionFeatureKey = 'extensionTypeOptions';

export type ExtensionTypeOptionState = EagerSelectState<ExtensionTypeOption>;

const adapter = createEagerSelectAdapter<ExtensionTypeOptionState, ExtensionTypeOption>({
   featureKey: extensionTypeOptionFeatureKey,
   selectId: (extension: ExtensionTypeOption) => {
      return extension.extensionTypeId;
   },
});

export const extensionTypeOptionSelectors = adapter.getSelectors(filterDisplayNamedOption);

const initialState = adapter.getInitialState();

export const extensionTypeOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   extensionTypeOptionActions.search,
   extensionTypeOptionActions.searchReset,
   extensionTypeOptionActions.loadFromApi,
   extensionTypeOptionActions.loadFromApiSuccess,
   extensionTypeOptionActions.loadFromApiFailure
);
